<template>
  <div>
    <div class="fixed">
      <transition name="fade">
        <div class="alert alert-danger" role="alert" v-if="profileUpdateFail">
          <span style="font-style: italic; font-weight: bold"> There was a problem updating your profile! </span>
        </div>
      </transition>
      <transition name="fade">
        <div class="alert alert-success" role="alert" v-if="profileUpdateSuccess">
          <span style="font-style: italic; font-weight: bold"> Profile successfully updated! </span> Redirecting to Home ...
        </div>
      </transition>
    </div>
    <div class="container">
      <CRow>
        <CCol lg="4">
          <CCard class="card-small mb-4 pt-3">
            <!-- Card Header -->
            <CCardHeader class="text-center" style="background-color: white">
              <!-- User Avatar -->
              <div class="mb-3 mx-auto">
                <avatar class="avatar-center" :username=username :size="150"></avatar>
              </div>
              <!-- User Name -->
              <h4 class="mb-0">{{ accountInformation.name }}</h4>
              <!-- User Job Title -->
              <span class="text-muted d-block mb-2"> {{ accountInformation.email }}</span>
              <!-- User Follow -->
              <CButton color="danger" class="mb-2" size="sm" variant="outline">Delete account</CButton>
            </CCardHeader>
            <CListGroup flush>
              <!-- User Performance Report -->
              <CListGroupItem class="px-4">
                <div class="progress-wrapper">
                  <strong class="text-muted d-block mb-2">Resilient Score</strong>
                  <CProgress
                      :value='score'
                      :color = 'color'
                      animated
                      show-value
                      style="width:100%;"
                      class="progress_bar"
                  />
                </div>
              </CListGroupItem>

              <!-- User Meta -->
              <CListGroupItem>
                <strong class="text-muted d-block mb-2">Description</strong>
                <span> {{ companyInformation.description }}</span>
              </CListGroupItem>
            </CListGroup>
          </CCard>
        </CCol>
        <CCol lg="8">
          <CCard>
            <CCardHeader align="left">
              <strong>Account Detail</strong>
            </CCardHeader>
            <CListGroup>
              <CListGroupItem>
                <CRow>
                  <CCol>
                    <CForm>
                      <fieldset class="border p-2">
                        <legend class="legend-style">Account Information</legend>
                        <CRow>
                          <CCol>
                            <CInput
                                v-model="accountInformation.name"
                                label="Full name"
                                placeholder="full name"
                                type="text"
                            />
                          </CCol>
                          <CCol>
                            <CInput
                                v-model="accountInformation.email"
                                label="Email"
                                placeholder="Email"
                                type="email"
                            />
                          </CCol>
                        </CRow>
                        <!-- <CRow>
                          <CCol>
                            <CInput
                                v-model="accountInformation.password"
                                label="Password"
                                placeholder="Password"
                                type="Password"
                            />
                          </CCol>
                        </CRow> -->
                      </fieldset>
                      <fieldset class="border p-2  my-4">
                        <legend class="legend-style">Company Information</legend>
                        <CInput
                            v-model="companyInformation.name"
                            label="Company Name"
                            placeholder="Company name"
                        />
                        <CInput
                            v-model="companyInformation.street"
                            label="Address"
                            placeholder="Address"
                        />
                        <CRow>
                          <CCol md="6">
                            <CInput
                                v-model="companyInformation.city"
                                label="City"
                                placeholder="City"
                            />
                          </CCol>
                          <CCol md="3">
                            <CInput
                                v-model="companyInformation.postalCode"
                                label="Zip"
                                placeholder="Zip code"
                            />
                          </CCol>
                        </CRow>
                        <CInput
                            v-model="companyInformation.country"
                            label="Country"
                            placeholder="Country"
                        />
                        <CTextarea
                            v-model="companyInformation.description"
                            label="Description"
                            placeholder="Summary"
                            rows="3"
                        />
                      </fieldset>
                      <div class="card_footer my-3">
                        <CButton type="reset" class="mx-3" color="danger" variant="outline" @click="reset">Reset</CButton>
                        <CButton type="submit" class="mx-3" color="primary" variant="outline" @click="save">Update</CButton>
                      </div>
                    </CForm>
                  </CCol>
                </CRow>
              </CListGroupItem>
            </CListGroup>
          </CCard>
        </CCol>
      </CRow>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import Avatar from "vue-avatar";

export default {
  name: "UserProfile",
  components: {
    Avatar
  },
  data () {
    return {
      company: '',
      user: '',
      profileUpdateSuccess: false,
      profileUpdateFail: false,
      avatar:require('@/assets/images/profile_avatar.jpg'),
      username: '',
      accountInformation: {
        email:'',
        name: '',
        password: ''
      },
      companyInformation: {
        name: '',
        street: '',
        city: '',
        postalCode: '',
        country: '',
        description: ''
      },
      score: 0,
      color: '#ff5d66',
      label: ''
    }
  },
  mounted() {
    document.title = 'Starter Grower | Profile'
    this.username = localStorage.getItem('name')
    this.getUserInfo()
    this.getResilientScore()
  },
  methods: {
    getUserInfo() {
      let self = this;
      const token = localStorage.getItem("api_token")
      axios.get(this.$apiAdress + '/api/profile', {
        headers: {
          Authorization: `Bearer ${token}`,
          Accept: 'application/json'
        }
      }).then(function (response) {
        console.log('user profile', response)
        self.companyInformation = response.data.data.company
        self.accountInformation = response.data.data.user
        console.log('account', self.accountInformation);
      }).catch(function (error) {
        console.log(error);
      });
    },
    save() {
      let self = this;
      const patchData = {
        company: self.companyInformation,
        user: self.accountInformation
      };
      const token = localStorage.getItem("api_token")
      axios.patch(this.$apiAdress + '/api/profile', patchData, {
        headers: {
          Authorization: `Bearer ${token}`,
          Accept: 'application/json'
        }
      })
      .then(function (response) {
        console.log('user profile', response)
        self.profileUpdateSuccess = true
        self.profileUpdateFail = false
        self.$router.push({ path: '/home' });
        // self.reset()
      }).catch(function (error) {
        console.log(error)
        self.profileUpdateFail = true
        // self.reset()

        setTimeout(function () {
          self.profileUpdateFail = !self.profileUpdateFail
        }.bind(this), 5000);
      });
    },
    reset() {
      let self = this
      // self.company = self.result.company
      // self.user = self.result.user
      self.getUserInfo()
    },

    getResilientScore() {
      let self = this;
      const token = localStorage.getItem("api_token")
      const company_id = localStorage.getItem("company_id")
      axios.get(this.$apiAdress + '/api/_score/' + company_id, {
        headers: {
          Authorization: `Bearer ${token}`,
          Accept: 'application/json'
        }
      }).then(function (response) {
        console.log('resilient score profile', response)
        self.score = response.data.data.score
        self.setColor(self.score)
      }).catch(function (error) {
        console.log(error);
      });
    },
    setColor(value) {
      const self = this
      if (value >= 75) {
        console.log('Excellent score')
        self.color = '#3ccdd0'
        self.label = 'Excellent'
      } else if (value < 75 && value >= 65) {
        console.log('Very good score')
        self.color = '#8dc53e'
        self.label = 'Very good'
      }else if (value < 65 && value >= 45) {
        console.log('Good score')
        self.color = '#fbdf58'
        self.label = 'Good'
      } else if (value < 45 && value >= 25) {
        console.log('Bad score')
        self.color = '#f7b65c'
        self.label = 'Bad'
      } else if (value < 25) {
        console.log('Very bad score')
        self.color = '#ff5d66'
        self.label = 'Very bad'
      }
    }
  }
}
</script>

<style scoped>
.legend-style {
  float: none;
  width: auto;
  padding-left: 10px;
  padding-right: 10px;
  font-size: 20px;

}

.container {
  display: flex;
  justify-content: center;
}

.action {
  display: flex;
  align-items: center;
  justify-content: center;
  /*height: 100vh;*/
}

.card_footer {
  justify-content: right;
  display: flex;
}

.fixed {
  position: fixed;
  width: 20%;
  bottom: 10px;
  z-index: 1;
  right: 2%;
}

.avatar-center {
  margin: auto;
  width: 50%;
  /*border: 3px #303c54;*/
  padding: 10px;
}
</style>
